module.exports = __webpack_public_path__ + "0c527e3acefd4055ce5a673eeeec4e4b.jpg";